import React, { FC } from 'react';
import { ReactComponent as Reoreder } from '../../../assets/Cashback/reorder.svg';

export const ReorderIcon: FC = () => <Reoreder />;
